import {
  FieldText as LookerFieldText,
  type FieldTextProps as LookerTextProps,
} from '@looker/components';

import { cls } from '@/utils/cls';

import style from './styles.module.scss';

export type FieldTextProps = {} & LookerTextProps;

export function FieldText({ className, value, ...props }: FieldTextProps) {
  return (
    <div>
      <LookerFieldText
        className={cls(
          style.fieldText,
          { [style.value]: Boolean(value) },
          className,
        )}
        value={value}
        {...props}
      />
    </div>
  );
}
